<template>
  <transition name="">
    <section class="viewer history active" id="viewerHistory">
      <h2 class="hide">활동내역 레이어</h2>
     	<button type="button" class="opinion_search_closed" @click="viewerHistoryClose()"></button>
       
      <div class="scroll_box">
			  <div class="day" :class="selectedDate == date ? '' : 'active'" v-for="(date, index) in dateList" :key="index">
				  <div class="day_tit" @click="selectDate(date)" v-if="today == date">{{ $i18nUtil.trans("message.today","오늘") }}</div>
          <div class="day_tit" @click="selectDate(date)" v-else-if="yesterday == date">{{ $i18nUtil.trans("message.yesterday","어제") }}</div>
          <div class="day_tit" @click="selectDate(date)" v-else>{{ date }}</div>
          <div class="box" v-for="(activityHistory, index) in fileActivityHistoryList" :key="index">
            <div class="point"><div></div></div>
            <div class="tit" 
              v-if="activityHistory.activityHistoryType === 'A' && 
                    activityHistory.activityKbn === 'LOCK'"
            >
              {{ $i18nUtil.trans("button.fileViewer.lock","편집잠금") }}
            </div>
            <div class="tit"
              v-if="activityHistory.activityHistoryType === 'A' &&
                    activityHistory.activityKbn === 'UNLOCK'"
            >
              {{ $i18nUtil.trans("button.fileViewer.unlock","편집잠금해제") }}
            </div>
            <div class="ver"
              v-if="activityHistory.activityHistoryType === 'V'"
            > 
              <span>{{ $i18nUtil.trans("message.fileViewer.ver","버전 {ver}", {ver: activityHistory.versionName}) }}</span>
              <span class="created" v-if="activityHistory.versionName === '1.0'">Created</span>
              <span class="now" v-else-if="activityHistory.activityHistoryId === latestVersionInfo.fileVersionId">{{ $i18nUtil.trans("message.fileViewer.currentVer","현재버전 {ver}", {ver: ""}) }}</span>
              <span class="update" v-else>Update</span>
            </div>
            <div class="tit"
              v-if="activityHistory.activityHistoryType === 'V'"
            >
              <div class="medium ell-singleline"
                :class="getFileExtIcon(fileInfo.fileExt)"
                @click="displayVersion(activityHistory.activityHistoryId)"
              >
                {{ fileInfo.fileName }}
              </div>
            </div>
            <div class="member">
              <div class="droplayer tooltipmember relative">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" class="name"><b>{{ $i18nUtil.getLanguage() !== 'ko' && activityHistory.regUserNameEn != null ? activityHistory.regUserNameEn : activityHistory.regUserName }}</b></v-btn>
                  </template>
                  <div class="dropdown-list">
                    <UserTooltip
                      :userId="activityHistory.regUserId"
                    />
                  </div>
                </v-menu>
              </div>
              <span class="date">{{ $moment(activityHistory.regDate).format("YYYY.MM.DD HH:mm") }}</span>
            </div>
          </div>
          <div class="btn_box txtc" v-if="selectedDate == date && pageIndex + 1 < totalPages && moreViewCount > 0">
            <button type="button" class="btn-more-ico_small1 down" @click="moreView()">{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: moreViewCount}) }}</button>
          </div>
        </div><!-- //day -->
		  </div> <!-- //scroll_box -->
    </section>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
export default {
  components: {
    UserTooltip
  },
  props: [
    'itemInfo', 'fileInfo', 'latestVersionInfo', 'currentVersionInfo'
  ],
  data() {
		return {
      reqData : {
        fileId: null,
        groupId: null,
        fileVersionId: null,
        sharepointSiteId: null,
		    sharepointFolderId: null,
		    sharepointFileId: null,
        type: 'SINGLE',
      },
      totalCount: 0,
      totalPages: 0,
      pageIndex: 0,
      pageSize: 10,
      today: '', // 오늘 날짜 YYYY.MM.DD
      yesterday: '', // 어제 날짜 YYYY.MM.DD
      selectedDate: '',
      dateList: [], // 날짜 목록 [YYYY.MM.DD]
      fileActivityHistoryList: [], // 전체 활동내역 목록
      currentCount : 0, // 현재 노출된 활동내역 건수
      moreViewCount : 0, // 더보기 활동내역 건수
    }
  },
  mounted() {
    let obj = this;

    obj.reqData = obj.itemInfo;
  },
	methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    /* 닫기 */
		viewerHistoryClose() {
			document.getElementById('viewerHistory').classList.toggle('active');
			this.$emit('viewerHistory');
    },
    /* 파일 활동 내역 등록일 목록 조회 */
    getFileActivityHistoryRegDateList() {
      let obj = this;

      obj.totalCount = 0;
      obj.totalPages = 0;
      obj.pageIndex = 0;
      obj.selectedDate = '';
      obj.currentCount = 0;
      obj.moreViewCount = 0;
      obj.fileActivityHistoryList = [];

      let reqData = {
        url: '/api/cofile/cofile/getFileActivityHistoryRegDateList',
        method: 'post',
        req: obj.reqData
      };

      obj
        .COWORK_REST_ACTION(reqData)
        .then(function(res) {
          let errorCode = res.errorCode;
          if (errorCode == null) {
            obj.today = res.result.today;
            obj.yesterday = res.result.yesterday;
            obj.selectedDate = res.result.regDateList[0];
            obj.dateList = res.result.regDateList;
            obj.getActivityHistoryListByRegDate();
          } else {
            console.log('Error Occured. errorcode : ' + errorCode);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 파일 활동 내역 목록 조회 */
    getActivityHistoryListByRegDate() {
      let obj = this;
      let reqData = {
        url: '/api/cofile/cofile/getFileActivityHistoryListByRegDate',
        method: 'post',
        req: {
          fileId : obj.reqData.fileId,
          regDate : obj.selectedDate,
          pageIndex : obj.pageIndex,
          pageSize : obj.pageSize
        }
      };

      obj.COWORK_REST_ACTION(reqData)
        .then(function(res) {
          let errorCode = res.errorCode;
          if(errorCode == null) {
            let currentFileActivityHistoryList = obj.fileActivityHistoryList;
            let currentCount = obj.currentCount;

            obj.totalCount = res.result.fileActivityHistoryList.totalElements;
            obj.totalPages = res.result.fileActivityHistoryList.totalPages;
            obj.currentCount = currentCount + res.result.fileActivityHistoryList.numberOfElements;

            for(let i=0; i<res.result.fileActivityHistoryList.content.length; i++) {
              currentFileActivityHistoryList.push(res.result.fileActivityHistoryList.content[i]);
            }

            obj.fileActivityHistoryList = currentFileActivityHistoryList;

            if(obj.totalCount - obj.currentCount >= obj.pageSize) {
              obj.moreViewCount = obj.pageSize;
            } else { 
              if(obj.totalCount - obj.currentCount > 0) {
                obj.moreViewCount = obj.totalCount - obj.currentCount;
              } else {
                obj.moreViewCount = 0;
              }
            }
          } else {
            console.log('Error Occured. errorcode : ' + errorCode);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    /* 날짜 선택 */
    selectDate(date) {
      let obj = this;
      let selectedDate = obj.selectedDate;
      
      if(selectedDate == date) {
        obj.totalCount = 0;
        obj.totalPages = 0;
        obj.pageIndex = 0;
        obj.selectedDate = '';
        obj.currentCount = 0;
        obj.moreViewCount = 0;
        obj.fileActivityHistoryList = [];
      } else {
        obj.totalCount = 0;
        obj.totalPages = 0;
        obj.pageIndex = 0;
        obj.selectedDate = date;
        obj.currentCount = 0;
        obj.moreViewCount = 0;
        obj.fileActivityHistoryList = [];
        obj.getActivityHistoryListByRegDate();
      }
    },
    /* 파일 버전 전환 */
    displayVersion(fileVersionId) {
      let obj = this;
      if(fileVersionId == obj.currentVersionInfo.fileVersionId) {
        return;
      }

      let version = {
        fileVersionId : fileVersionId
      };
      
      obj.$emit('displayOtherVersion', version);
    },
    /* 더보기 클릭 */
    moreView() {
      let obj = this;
      let pageIndex = obj.pageIndex;

      obj.pageIndex = pageIndex + 1;
      obj.getActivityHistoryListByRegDate();
    },
    /* 파일 확장자 아이콘 */
    getFileExtIcon(ext) {
      if(ext == null) {
        return "";
      }

      let fileExt = ext;
      if(fileExt == 'ppt' || fileExt == 'pptx' || fileExt == 'pptm' || fileExt == 'pot' || fileExt == 'potx' || fileExt == 'potm' || fileExt == 'pps' || fileExt == 'posx') {
        return 'ico-file-ppt';
      } else if(fileExt == 'doc' || fileExt == 'docx' || fileExt == 'docm' || fileExt == 'dot' || fileExt == 'dotx'  || fileExt == 'dotm') {
        return 'ico-file-word';
      } else if(fileExt == 'xls' || fileExt == 'xlsx' || fileExt == 'xlsm' || fileExt == 'xlsb' || fileExt == 'xlt' || fileExt == 'xltm') {
        return 'ico-file-xlsx';
      } else if(fileExt == 'pdf') {
        return 'ico-file-pdf';
      } else if(fileExt == 'jpg' || fileExt == 'jpeg') {
        return 'ico-file-jpg';
      } else if(fileExt == 'gif') {
        return 'ico-file-gif';
      } else if(fileExt == 'png') {
        return 'ico-file-png';
      } else if(fileExt == 'tif') {
        return 'ico-file-tif';
      } else if(fileExt == 'tiff') {
        return 'ico-file-tiff';
      } else if(fileExt == 'bmp') {
        return 'ico-file-bmp';
      } else if(fileExt == 'zip') {
        return 'ico-file-zip';
      } else if(fileExt == 'hwp') {
        return 'ico-file-hwp';
      } else {
        return 'ico-file-etc';
      }
    }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/file/activity/ViewerActivityHistoryByRegDate.vue